import { useContext } from 'react';
import { ISOReportsTableContext, IISOReportTableContext } from './ISOReportsTableContext';

export const useISOReportsTable = () => useContext<IISOReportTableContext>(ISOReportsTableContext);
